import * as React from 'react';
import { graphql } from 'react-apollo';

import PendingRolesButton from 'roleRequests/components/PendingRolesButton';

// @ts-ignore
import ROLE_REQUESTS_BUTTON_QUERY from './queries/RoleRequestsButtonQuery.gql';
import {
  RoleRequestsButtonQueryVariables,
  RoleRequestsButtonQuery,
  RoleRequestsButtonQuery_organizations,
} from './queries/__generated__/RoleRequestsButtonQuery';

// @ts-ignore
import { errorFragment } from 'queries/__generated__/errorFragment';

import { findMatchingRecord } from 'utils/arrayHelpers';

type Props = {
  groupName: string;
  organizationUuid: string;
  roleRequestsCount: number;
  gatedRoles: string[];
  loading: boolean;
  error: errorFragment;
};

class PendingRolesButtonContainer extends React.Component<Props> {
  static defaultProps = {
    roleRequestsCount: 0,
    loading: false,
  };

  render() {
    const { groupName, roleRequestsCount, gatedRoles } = this.props;

    if (gatedRoles && gatedRoles.includes('teacher')) {
      return <PendingRolesButton roleRequestsCount={roleRequestsCount} groupName={groupName} />;
    }

    return null;
  }
}

const withData = graphql<Props, RoleRequestsButtonQuery, RoleRequestsButtonQueryVariables>(
  ROLE_REQUESTS_BUTTON_QUERY,
  {
    options: ({ organizationUuid }) => {
      return {
        variables: {
          organizationUuid,
          role: 'teacher',
        },
        fetchPolicy: 'network-only',
      };
    },
    props: ({ data, ownProps: { organizationUuid } }) => {
      if (data) {
        const props: any = {};
        props.loading = data.loading;
        props.error = data.error;

        const organization = findMatchingRecord<RoleRequestsButtonQuery_organizations>(
          data.organizations,
          organizationUuid
        );
        if (organization) {
          props.roleRequestsCount = organization.roleRequestCount;
          props.gatedRoles = organization.gatedRoles;
        }

        return props;
      }
      return {};
    },
  }
);

export { PendingRolesButtonContainer };
export default withData(PendingRolesButtonContainer);
